<template>
  <b-form-group
    label="4. Alamat"
    label-for="alamat"
  >
    <b-form-textarea
      id="alamat"
      v-model="alamat"
      disabled
    />

    <b-col
      cols="11"
      offset-md="1"
      class="mt-1 pr-0"
    >
      <b-form-group
        label="Provinsi"
        label-for="provinsi"
        class="mt-1"
      >
        <b-form-select
          id="provinsi"
          v-model="provinsi"
          :options="dataProvinsi"
          disabled
        />
      </b-form-group>

      <b-form-group
        label="Kabupaten/Kota"
        label-for="kabKota"
        class="mt-1"
      >
        <b-form-select
          id="kabKota"
          v-model="kabKota"
          :options="dataKabKota"
          disabled
        />
      </b-form-group>

      <b-form-group
        label="Kecamatan"
        label-for="kecamatan"
      >
        <b-form-select
          id="kecamatan"
          v-model="kecamatan"
          :options="dataKecamatan"
          disabled
        />
      </b-form-group>
      <b-form-group
        label="Kelurahan"
        label-for="kelurahan"
      >
        <b-form-select
          id="kelurahan"
          v-model="kelurahan"
          :options="dataKelurahan"
          disabled
        />
      </b-form-group>
      <b-form-group
        label="Jalan"
        label-for="jalan"
      >
        <slot name="jalan" />
      </b-form-group>
      <b-row>
        <b-col cols="2">
          <b-form-group
            label="No"
            label-for="noAlamat"
          >
            <slot name="noAlamat" />
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group
            label="RT"
            label-for="rt"
          >
            <slot name="rt" />
          </b-form-group>
        </b-col>
        <b-col cols="2">
          <b-form-group
            label="RW"
            label-for="rw"
          >
            <slot name="rw" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
            label="Kode Pos"
            label-for="kodePos"
          >
            <b-form-input
              id="kodePos"
              v-model="kodePos"
              disabled
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-col>
  </b-form-group>
</template>
<script>
const propsString = { type: String, default: '' }
const propsArray = { type: Array, default: () => [] }
export default {
  props: {
    alamat: propsString,
    provinsi: propsString,
    dataProvinsi: propsArray,
    kabKota: propsString,
    dataKabKota: propsArray,
    kecamatan: propsString,
    dataKecamatan: propsArray,
    kelurahan: propsString,
    dataKelurahan: propsArray,
    kodePos: propsString,
  },
}
</script>
